var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"overlay"})}
var staticRenderFns = []

export { render, staticRenderFns }